export default __webpack_public_path__ + "static/two-076e288814752920a240fc728b7abb27.jpg";